module.exports = __webpack_public_path__ + "img/front_Blank.b7c6f178.svg";